import { CoreFieldProps, fieldTypes } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { PersonalAccountRiskReview } from "@/types/PersonalAccountRiskReview";

export interface PersonalAccountRiskReviewComplexFieldProps
  extends fieldTypes.BaseFieldProps<PersonalAccountRiskReview> {}

export const PersonalAccountRiskReviewComplexField: FC<PersonalAccountRiskReviewComplexFieldProps> = (props) => { 
  return (
    <section className="complex-field-container risk-review">
      <div className="complex-field-content">
        <FieldComplexV2 {...props} complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_RISK_REVIEW.LOCATION} complexFieldProps={{
          showClearButton: true,
        } as Partial<CoreFieldProps>} />
        <FieldComplexV2 {...props} complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_RISK_REVIEW.NSF_HISTORY} complexFieldProps={{
          showClearButton: true,
        } as Partial<CoreFieldProps>} />
        <FieldComplexV2 {...props} complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_RISK_REVIEW.NEGATIVE_SOCIAL_MEDIA_CHECK} complexFieldProps={{
          showClearButton: true,
        } as Partial<CoreFieldProps>} />
        <FieldComplexV2 {...props} complexFieldKey={COMPLEX_FIELD_KEYS.PERSONAL_ACCOUNT_RISK_REVIEW.ADDRESS_VERIFICATION} complexFieldProps={{
          showClearButton: true,
        } as Partial<CoreFieldProps>} />
      </div>
    </section>
  );
} 